import { useEffect } from 'react'
import { SuspenseLoader } from 'v2/shared/components/suspense-loader'
import { useAppNavigate } from 'v2/shared/hooks/use-app-navigate'
import { settingsService } from 'v2/shared/services/settings-service'
import { errorToast } from 'v2/utils/toasts'

// Exported component
export const SupportLogin = () => {
  const navigate = useAppNavigate()

  useEffect(() => {
    let cancelled = false
    const doRedirect = async () => {
      try {
        const query = window.location.search.replace(/^\?/, '')
        const { data } = await settingsService.getSupportLogin(query)
        if (!cancelled && data?.url) {
          window.location.href = data.url
          return
        }
        throw new Error('No redirect URL received')
      } catch (err) {
        if (!cancelled)
          errorToast({
            title:
              err instanceof Error
                ? err.message
                : 'Something went wrong while redirecting to support',
          })
        if (!cancelled) navigate('/home')
      }
    }
    doRedirect()
    return () => {
      cancelled = true
    }
  }, [navigate])

  return <SuspenseLoader text="Redirecting to support..." />
}
